export const language: any = {
  selected_ingredients: 'Bahan yang dipilih',
  recommend: 'Hidangan yang direkomendasikan',
  title_detail: 'Resep yang Direkomendasikan',
  share: 'Bagikan',
  ingredients: {
    title: `<span class="tracking-tighter whitespace-nowrap">Bahan</span> <span class="tracking-tighter whitespace-nowrap">(1 porsi)</span>`,
    add_all: 'Tambah semua bahan',
    view_more: '{number} bahan lainnya',
    view_less: 'Lipat',
    delete_all: 'Hapus semua bahan',
  },
  how_to_cook: 'Metode memasak',
  video: {
    title: 'Resep video',
  },
  msg: {
    msg_1: "Apakah Anda yakin ingin menghapus bahan ini?",
    msg_2: "Apakah Anda yakin ingin menghapus semua bahan?",
    msg_3: "Apakah Anda ingin menambahkan bahan-bahan ini?",
    msg_4: "Apakah Anda ingin menambahkan semua bahan yang hilang?",
    msg_5: "Apakah Anda ingin menambahkan bahan yang dipilih ke keranjang belanja Anda?",
    msg_6: "Bahan ini sudah ada di keranjang belanja Anda.",
    confirm: "Ya",
    cancel: "Tidak",
  },
  recipe_exist_in_cart: "Bahan ini sudah ada di keranjang belanja Anda.",
  recipe_want_add_to_cart: "Apakah Anda ingin menambahkan bahan yang dipilih ke keranjang belanja Anda?",
  recipe_exist_in_cart_should_exclued: "sudah ada di keranjang saat ini, jadi telah dikecualikan.",
  calories_description: "Makanan ini diperkirakan mengandung {calories} berdasarkan resep di bawah ini. Silakan pertimbangkan untuk membuat pilihan yang tepat demi kesehatan Anda!",
  title_share_sns: "Bagikan resep ini di",
  copy: "Salin",
  recipe_add_cart_success: "Berhasil ditambahkan ke keranjang. Apakah Anda ingin pergi ke layar keranjang?",
  recipe_close: "Tutup",
  recipe_move: "Pindah",
  recipe_add_ingredient_success: "Bahan yang dipilih telah ditambahkan. Apakah Anda ingin beralih ke layar bahan?",
  copied: "Disalin",
  text_share_sns: `{recipe_name} bagaimana dengan resep ini? Cek di Hey! Cooker!`,
  search: {
    title: "Cari Resep",
    searching: "Hey Cooker sedang mencari resep yang cocok<br/> dengan kata kunci Anda, harap tunggu sebentar!",
    not_found: "Hmm, koki AI tidak menemukan hidangan yang cocok<br/> dengan kata kunci Anda, silakan coba masukkan nama hidangan lain.",
    placeholder: "Masukkan nama resep yang ingin Anda cari...",
    msg_default_recipe: "Anda belum memiliki resep apa pun",
  },
  noData: "Tidak ada hasil ditemukan",
  searching: "Mencari..."
}
